<template>
  <div class="order">
    <div class="head">
      <AppFrame/>
      <div class="search-box">
        <van-search v-model="svalue" shape="round" clearable placeholder="请输入发货单号/单位/地点" :left-icon="require('@/styles/img/icon_search.png')" background="transparent" @search="onSearch"/>
      </div>
    </div>
    <div class="cont">
      <van-tabs v-model="active" @click="onClick">
        <van-tab v-for="(item,index) in tabs" :key="index" :name="item.id" :title="item.label">
        </van-tab>
      </van-tabs>
      <div>
        <!-- 列表页 -->
        <transport-order-list :channel="status"></transport-order-list>
      </div>
    </div>
  </div>
</template>

<script>
import AppFrame from '@/components/AppFrame'
import SearchBar from '@/components/SearchBar'
import TransportOrderList from '../../components/List/TransportOrderList'
export default {
  name: "TransportOrder",
  components: {
    TransportOrderList,
    AppFrame,
    SearchBar
  },
  data() {
    return {
      svalue:'',
      status:'',
      active:0,
      tabs: [
        {
            id:'0',
            label:'全部',
        },
        {
            id:'1',
            label:'未发布',
        },
        {
            id:'3',
            label:'待确认',
        },
        {
            id:'5',
            label:'已确认',
        }
      ],
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onClick(name, title) {
      this.status = name
      this.bus.$emit('transportOrderTabsId', {
        transportOrderTabsId: name
      })
    },
    onSearch(val) {
      this.bus.$emit('svalue', {
        svalue: val
      })
    },
  },
  destroyed() {
  }
};
</script>
<style scoped lang="less">
  @import '../../styles/order.less';
</style>



// WEBPACK FOOTER //
// src/pages/Invoice/TransportOrder.vue